<template>
  <section id="availability">
    <div class="availability-box center-container">
      <h2>Orçamento e <span>Disponibilidade</span></h2>
      <div class="inputs">
        <div class="input-group">
          <label for="checkin-date">Data de entrada</label>
          <input type="date" :min="minCheckinDate" :value="checkinDate" @input="updateCheckinDate" name="checkin-date">
        </div>
        <div class="input-group">
          <label for="checkout-date">Data de saída</label>
          <input type="date" :min="minCheckoutDate" :value="checkoutDate" @input="updateCheckoutDate" name="checkout-date">
        </div>
        <div class="mobile-aside">
          <div class="input-group">
            <label for="adults">Adultos</label>
            <input type="number" min="1" :value="qtdAdults" @input="updateQtdAdults" name="adults">
          </div>
          <div class="input-group">
            <label for="childrens">Crianças</label>
            <input type="number" min="0" :value="qtdChilds" @input="updateQtdChilds" name="childrens">
          </div>
        </div>
        <div class="input-group">
          <anchor-router-link class="btn btn-primary" :scrollOptions="linkOptions" :to="{name: 'home', hash: '#formulario'}">Fazer orçamento</anchor-router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AnchorRouterLink from 'vue-anchor-router-link'
import { mapState } from 'vuex'

export default {
  name: 'Availability',
  components: {
    AnchorRouterLink
  },
  data () {
    return {
      minCheckinDate: this.formatDate(new Date()),
      minCheckoutDate: this.formatDate(new Date()),
      linkOptions: {
        container: 'body',
        duration: 700,
        easing: 'ease',
        offset: 0,
        cancelable: true,
        onStart: false,
        onDone: this.focusField,
        onCancel: false,
        x: false,
        y: true
      }
    }
  },
  computed: {
    ...mapState({
      qtdAdults: state => state.qtdAdults,
      qtdChilds: state => state.qtdChilds,
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate
    })
  },
  methods: {
    updateQtdAdults (e) {
      this.$store.commit('updateQtdAdults', e.target.value)
    },
    updateQtdChilds (e) {
      this.$store.commit('updateQtdChilds', e.target.value)
    },
    formatDate (date) {
      return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]
    },
    updateCheckinDate (e) {
      this.$store.commit('updateCheckinDate', e.target.value)
      this.minCheckoutDate = this.checkinDate
    },
    updateCheckoutDate (e) {
      this.$store.commit('updateCheckoutDate', e.target.value)
    },
    focusField () {
      this.$store.commit('focusField')
    }
  }
}
</script>
